// components/NewsletterSignup.jsx
import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Container, 
  Paper,
  Snackbar,
  Alert
} from '@mui/material';
import { FaEnvelope } from 'react-icons/fa';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (error) setError(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailPattern.test(email)) {
      setError(true);
      return;
    }
    
    // In a real implementation, you would send this to your backend
    console.log('Newsletter signup:', email);
    setOpenSnackbar(true);
    setEmail('');
  };

  return (
    <Box 
      sx={{ 
        py: 12, 
        bgcolor: 'background.paper',
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #0a1929 0%, #152238 100%)',
        borderTop: '1px solid rgba(255,255,255,0.05)',
        boxShadow: 'inset 0 5px 20px rgba(0,0,0,0.2)',
      }}
    >
      <Container maxWidth="md">
        <Paper 
          elevation={6}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            background: 'rgba(26, 46, 66, 0.8)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
          }}
        >
          <Box 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center'
            }}
          >
            <Box 
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 64,
                height: 64,
                borderRadius: '50%',
                backgroundColor: 'secondary.main',
                mb: 3
              }}
            >
              <FaEnvelope size={24} color="#0a1929" />
            </Box>

            <Typography 
              variant="h3" 
              gutterBottom 
              sx={{ fontWeight: 700 }}
            >
              Get the Latest Updates
            </Typography>
            
            <Typography 
              variant="body1" 
              sx={{ 
                mb: 4, 
                maxWidth: 600,
                opacity: 0.9
              }}
            >
              Subscribe to our newsletter for exclusive movie news, special promotions, advance ticket opportunities, and behind-the-scenes content.
            </Typography>
            
            <Box 
              component="form" 
              onSubmit={handleSubmit}
              sx={{ 
                display: 'flex', 
                width: '100%',
                maxWidth: 500,
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 2, sm: 0 }
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Your email address"
                value={email}
                onChange={handleChange}
                error={error}
                helperText={error ? "Please enter a valid email" : ""}
                sx={{
                  bgcolor: 'background.default',
                  borderRadius: '4px 0 0 4px',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'rgba(255, 255, 255, 0.2)',
                      borderRight: { sm: 0 }
                    },
                  },
                }}
              />
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                sx={{ 
                  px: 4,
                  whiteSpace: 'nowrap',
                  borderRadius: { xs: '4px', sm: '0 4px 4px 0' }
                }}
              >
                Subscribe
              </Button>
            </Box>
            
            <Typography variant="body2" sx={{ mt: 2, opacity: 0.7 }}>
              We respect your privacy. Unsubscribe at any time.
            </Typography>
          </Box>
        </Paper>
      </Container>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setOpenSnackbar(false)} 
          severity="success" 
          variant="filled"
          sx={{ width: '100%' }}
        >
          Thank you for subscribing!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default NewsletterSignup;